// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reviewBudgetStyles } from "@insite/content-library/Widgets/Budget/ReviewBudget";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

reviewBudgetStyles.filterWrapper = {
    css: css`
        margin: 25px 0 15px 0;
        display: flex;
        flex-wrap: wrap;
    `,
};

reviewBudgetStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        margin: 0 30px 15px 0;
        ${xScreen("lte", "md")} {
            flex-basis: calc(100% / 3 - 30px);
            max-width: calc(100% / 3 - 30px);
        }
        ${xScreen("lte", "sm")} {
            flex-basis: 100%;
            max-width: 100%;
        }
    `,
};

reviewBudgetStyles.titleText = {
    as: "h2",
    variant: "h4",
    css: css`
        margin: 16px 0;
    `,
};
